/**
 * Note: `thead`, `tbody`, `tr`, `th`, `td` must be inside a `<table>`
 * @param {TemplateStringsArray} template
 * @param  {...any} substitutions
 */
export function html (template, ...substitutions) {
  return parseHtml(String.raw(template, ...substitutions));
}

/**
 * @param {string} string
 * @returns {HTMLCollection}
 */
function parseHtml (string) {
  const tmp = document.createElement('div');
  tmp.innerHTML = string;
  return tmp.children;
}

export default parseHtml;
